import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportTrash extends Schema {
    @type("number")
    @defaultValue(-1)
    carrier: number;
    @type("number")
    @defaultValue(0)
    serial: number;
    @type("number")
    @defaultValue(0)
    kind: number;
}
